(function($, undefined) {
	
	'use strict';
	
	var createSelects = function() {
		var selects = document.querySelectorAll('select.change-select-js');
		
		for(var i = 0; i < selects.length; i++) {
			var select = selects[i];
			var options = select.querySelectorAll('option');
			var parent = select.parentNode;
			var newSelect = document.createElement('div');
			var optionsContainer = document.createElement('div');
			var selectedValue = document.createElement('div');
			var optionsValues = '';
			
			for (var k = 0; k < select.attributes.length; k++) {
				var selectAttr = select.attributes[k];
				selectedValue.setAttribute(selectAttr.name, selectAttr.nodeValue || selectAttr.value);
			}
			
			newSelect.className = 'select-changed-js';
			
			optionsContainer.className = 'select-options-container';
			
			selectedValue.classList.remove('change-select-js');
			selectedValue.classList.add('select-value');
			selectedValue.setAttribute('tabindex', '0');
			
			for(var j = 0; j < options.length; j++) {
				var option = options[j];
				var newOption = document.createElement('div');
				var value = getValue(option);
				newOption.setAttribute('data-value', value);
				newOption.innerText = option.innerText;
				
				for (var l = 0; l < option.attributes.length; l++) {
					var optionAttr = option.attributes[l];
					newOption.setAttribute(optionAttr.name, optionAttr.nodeValue || optionAttr.value);
				}
				
				if(option.selected) {
					selectedValue.innerText = newOption.innerText;
					selectedValue.setAttribute('data-value', value);
					newOption.className = 'select-option selected hover';
				} else {
					newOption.className = 'select-option';
				}
				
				if(optionsValues.length) {
					optionsValues += '\n';
				}
				optionsValues += option.innerText;
				
				optionsContainer.appendChild(newOption);
			}
			
			newSelect.setAttribute('data-items', optionsValues);
			
			newSelect.appendChild(selectedValue);
			newSelect.appendChild(optionsContainer);
			parent.insertBefore(newSelect, select);
			parent.removeChild(select);
			
			setupListeners(newSelect, selectedValue, optionsContainer);
		}
	};
	
	var setupListeners = function(newSelect, selectValue, optionsContainer) {
		var options = optionsContainer.querySelectorAll('.select-option');
		
		selectValue.addEventListener('mousedown', toggleOptionsContainer);
		newSelect.addEventListener('focusin', startListeningForKeys);
		newSelect.addEventListener('focusout', stopListeningForKeys);
		
		for(var i = 0; i < options.length; i++) {
			var option = options[i];
			option.addEventListener('mouseup', updateSelectedValue);
			option.addEventListener('mouseover', optionOver);
			option.addEventListener('mouseout', optionOver);
		}
	};
	
	var optionOver = function(e) {
		if(e.type === 'mouseout') {
			var target = document.elementFromPoint(e.clientX, e.clientY);
			if(target) {
				if(target.classList.contains('select-option')) {
					this.classList.remove('hover');
				}
			}
			this.removeEventListener('mousemove', optionOver);
		} else if(e.type === 'mouseover' || e.type === 'mousemove') {
			var hovered = getHovered(this.parentNode);
			
			if(e.type === 'mouseover' || hovered !== this) {
				hovered.classList.remove('hover');
				this.classList.add('hover');
			}
			
			if(e.type === 'mouseover'){
				this.addEventListener('mousemove', optionOver);
			}
		}
	};
	
	var startListeningForKeys = function() {
		window.addEventListener('keydown', selectKeydown);
		this.classList.add('select-focused');
	};
	
	var stopListeningForKeys = function() {
		window.removeEventListener('keydown', selectKeydown);
		this.classList.remove('select-focused');
	};
	
	var selectKeydown = function(e) {
		var container = document.querySelector('.select-focused .select-options-container');
		var isOpened = container.classList.contains('show-options');
		var key = getKey(e.code || e.which);
		
		// Allows for other keys to work as they should
		if(key.isOneOfKeys || (isOpened && !key.isOneOfKeys)) {
			e.preventDefault();  
			e.stopPropagation();
			
			if(key.code === 'Tab' || key.code === 9) {
				toggleOptionsContainer.apply(container.previousElementSibling);
			}
		}
		
		if(isOpened) {
			if(key.isEnter || key.isEscape) {
				toggleOptionsContainer.apply(container.previousElementSibling);
			}
		} else {
			if(key.isSpace) {
				toggleOptionsContainer.apply(container.previousElementSibling);
			}
		}
		
		if(key.isUp) {
			goToPrevValue(container, e);
		} else if(key.isDown) {
			goToNextValue(container, e);
		} else if(key.isKey) {
			goToNextKeyValue(container, e, key.code);
		}
	};
	
	var toggleOptionsContainer = function() {
		var options = this.nextElementSibling;
		var currentHover = getHovered(options);
		var currentSelected = getSelected(options);
		
		options.classList.toggle('show-options');
		
		currentHover.classList.remove('hover');
		currentSelected.classList.add('hover');
		
		if(options.classList.contains('show-options')) {
			setTimeout(function() {
				window.addEventListener('mousedown', closeToggled);
			}, 1);
		} else {
			window.removeEventListener('mousedown', closeToggled);
		}
	};
	
	var closeToggled = function(e) {
		var classesRegex = /select-option|select-changed-js|select-value|select-options-container/;
		var target = e.target;
		var isSelect = false;
		if(e.target.className.match(classesRegex)) {
			if(target.classList.contains('select-focused')) {
				isSelect = true;
			} else {
				while(target) {
					if(target.classList.contains('select-focused')) {
						isSelect = true;
						break;
					} else if(!target.className.match(classesRegex)) {
						break;
					}
					target = target.parentNode;
				}
			}
		}
		
		if(!isSelect) {
			var containers = document.querySelectorAll('.show-options');
			for( var i = 0; i < containers.length; i++) {
				var option = containers[i];
				toggleOptionsContainer.apply(option.previousElementSibling);
			}
		}
	};
	
	var updateSelectedValue = function(e, fromKey) {
		var parent = this.parentNode;
		var select = parent.parentNode;
		var selectedValue = parent.previousElementSibling;
		var previousOption = getSelected(parent);
		var previousOver = getHovered(parent);
		var changeEvent;
		
		if(typeof window.CustomEvent === 'function') {
			changeEvent = new CustomEvent('change', {
				originalEvent: e,
				type: 'change'
			});
		} else {
			changeEvent = document.createEvent('CustomEvent');
			changeEvent.initCustomEvent('change', true, true, {
				originalEvent: e,
				type: 'change'
			});
		}
		
		e.preventDefault();
		
		previousOption.classList.remove('selected');
		this.classList.add('selected');
		
		selectedValue.setAttribute('data-value', this.getAttribute('data-value'));
		selectedValue.innerHTML = this.innerHTML;
		
		if(!fromKey) {
			toggleOptionsContainer.apply(selectedValue);
		} else {
			parent.scrollTop = this.offsetTop;
			previousOver.classList.remove('hover');
			this.classList.add('hover');
		}
		
		if(selectedValue.dispatchEvent) {
			selectedValue.dispatchEvent(changeEvent);
		} else {
			selectedValue.fireEvent(changeEvent);
		}
	};
	
	var goToPrevValue = function(container, e) {
		var hover = getHovered(container);
		var prev = hover.previousElementSibling;
		
		if(prev) {
			updateSelectedValue.apply(prev, [e, true]);
		}
	};
	
	var goToNextValue = function(container, e) {
		var hover = getHovered(container);
		var next = hover.nextElementSibling;
		
		if(next) {
			updateSelectedValue.apply(next, [e, true]);
		}
	};
	
	var goToNextKeyValue = function(container, e, key) {
		var hover = getHovered(container);
		var options = container.querySelectorAll('.select-option');
		var found = false;
		var isNumber = !isNaN(key);
		var keyReplaced = isNumber ? 'asdsadas' : key.replace(/Key|Digit/, ''); 
		var next = hover;
		
		for(var i = 0; i < options.length; i++) {
			next = next.nextElementSibling;
			
			if(!next) {
				next = container.children[0];
			}
			
			if(isNumber) {
				if(next.innerHTML.charCodeAt(0) === key) {
					found = true;
					break;
				}
			} else {
				if(next.innerHTML.charAt(0).toUpperCase() === keyReplaced) {
					found = true;
					break;
				}
			}
		}
		
		if(found) {
			updateSelectedValue.apply(next, [e, true]);
		}
	};
	
	var getValue = function(option) {
		if(!option.hasAttribute('value')) {
			return option.innerText;
		} else {
			return option.getAttribute('value');
		}
	};
	
	var getKey = function(key) {
		var data = {
			code: key,
			isEnter: false,
			isKey: false,
			isEscape: false,
			isSpace: false,
			isUp: false,
			isDown: false,
			isOneOfKeys: false,
			keyValue: undefined
		};
		var isNumber = (key >= 48 && key <= 57);
		var isLetter = (key >= 65 && key <= 90);
		
		if(key === 13 || key === 'Enter') {
			data.isEnter = true;
		} else if(key === 27 || key === 'Escape') {
			data.isEscape = true;
		} else if(key === 32 || key === ' ' || key === 'Space') {
			data.isSpace = true;
		} else if(key === 38 || key === 37 || key === 'ArrowLeft' || key === 'ArrowUp') {
			data.isUp = true;
		} else if(key === 40 || key === 39 || key === 'ArrowRight' || key === 'ArrowDown') {
			data.isDown = true;
		} else if(isNumber || isLetter || (/[a-z0-9]{1}/i.test(key) && key.length === 1) || /(Key[A-Z])|(Digit[0-9])/.test(key)) {
			data.isKey = true;
			
			if(isNumber || isLetter) {
				keyValue = String.fromCharCode(key);
			} else {
				keyValue = key;
			}
		}
		
		if(data.isEnter || data.isEscape || data.isSpace || data.isUp || data.isDown || data.isKey) {
			data.isOneOfKeys = true;
		}
		
		return data;
	};
	
	var getHovered = function(container) {
		var hover = container.querySelector('.hover');
		
		if(!hover) {
			hover = container.querySelector('.select-option');
		}
				
		return hover;
	};
	
	var getSelected = function(container) {
		var selected = container.querySelector('.selected');
		
		if(!selected) {
			selected = container.querySelector('.select-option');
		}
		
		return selected;
	};
	
	var getSelectValue = function(selectCtn) {
		var selectItem;
		if(typeof selectCtn === 'string') {
			selectItem = document.querySelector(selectCtn);
			if(!selectItem) {
				return null;
			}
		} else if(typeof selectCtn === 'object') {
			if(selectCtn[0]) {
				selectItem = selectCtn[0];
			} else {
				return null;
			}
		} else if(selectCtn && selectCtn.nodeType) {
			selectItem = selectCtn;
		} else {
			return null;
		}
		
		try {
			return selectItem.querySelector('.select-value').getAttribute('data-value');
		} catch(ex) {
			console.error(ex);
			return null;
		}
	};
	
	
	$(document).ready(function() {
		createSelects();
	});
	
	var customSelect = Fw.component.export('customSelect', {
		val: getSelectValue
	});
	
})(jQuery);
